<template>
  <v-dialog
    v-model="active"
    width="400px"
    persistent
  >
    <template v-slot:activator="{on}">
      <slot name="activator" v-bind="{ on: on}"/>
    </template>
    <v-card>
      <v-container
        fluid
        class="card__header"
      >
        <v-row
          align="center"
          class="ma-0 p-relative"
        >
          <span class="card__title">Defina o período do Planejamento</span>
          <v-spacer/>
          <v-btn
            icon
            x-small
            color="#E5E8E7"
            :disabled="creating"
            @click="() => active = false"
          >
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-divider/>
      <v-container fluid>
        <v-row
          class="ma-0"
        >
          <v-col cols="6">
            <v-text-field
              outlined
              readonly
              :value="startDateFormatted"
              label="Início"
              clearable
              :error-messages="startDateErrors"
              @click:clear="onStartDateClear"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              readonly
              :value="endDateFormatted"
              label="Término"
              clearable
              :error-messages="endDateErrors"
              @click:clear="onEndDateClear"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-date-picker
              flat
              v-model="range"
              header-color="#7B9596"
              color="#7B9596"
              range
              :min="minDate"
              :max="maxDate"
              width="100%"
            />
          </v-col>
        </v-row>
        <v-row
          class="ma-0"
        >
          <v-btn
            outlined
            color="primary"
            :disabled="creating"
            @click="() => active = false"
          >
            Cancelar
          </v-btn>
          <v-spacer/>
          <v-btn
            depressed
            color="#2BC1B6"
            class="white--text"
            @click="onConfirmClick"
            :loading="creating"
          >
            Confirmar
          </v-btn>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {validationMixin} from "vuelidate"
import moment from "moment"
import {required} from "vuelidate/lib/validators"
import {ref, withParams} from "vuelidate/lib/validators/common"
import {SlaughterProgrammingStepsEventBus} from "@/modules/programacaoAbate/events"


const maxDateDiff = (prop) =>
  withParams({type: 'maxDateDiff', prop}, function (value, parentVm) {
    let startDate = ref(prop, this, parentVm)
    if (!startDate) return false
    startDate = moment(startDate)
    const endDate = moment(value)
    const dateDiffInDays = endDate.diff(startDate, "days")
    return dateDiffInDays <= 7
  })

export default {
  name: "NovoPlanejamentoAlojamentoDialog",
  mixins: [validationMixin],
  data: () => ({
    active: false,

    startDate: null,
    endDate: null,
    range: [],
    creating: false,
  }),
  validations: {
    startDate: {
      required,
    },
    endDate: {
      required,
      maxDateDiff: maxDateDiff("startDate")
    }
  },
  methods: {
    onConfirmClick() {
      this.$v.$touch()

      if (this.$v.$invalid) return

      const payload = {
        dt_inicio_alojamento: moment(this.startDate).format("YYYY-MM-DD"),
        dt_fim_alojamento: moment(this.endDate).format("YYYY-MM-DD"),
        cd_status_planejamento_alojamento: 1
      }
      this.creating = true
      this.$axios.post('/planejamento-alojamento/', payload)
        .then(response => {
          if (!response.data) return
          if (!response.data[0].data) return

          this.active = false
          this.$router.push('planejamentoAlojamento/' + response.data[0].data.idPlanejamentoAlojamento + '/preAlojamento')
        })
        .catch((err) => {
          this.$store.commit("setSnack", {
            type: "error",
            msg: err
          })
        })
        .finally(() => {
          this.creating = false
        })
    },
    onStartDateClear() {
      this.startDate = null
      if (this.range) this.range = []
    },
    onEndDateClear() {
      this.endDate = null
      if (this.range) this.range = []
    },
  },
  computed: {
    startDateFormatted() {
      if (!this.startDate) return null
      return moment(this.startDate).format("DD/MM")
    },
    endDateFormatted() {
      if (!this.endDate) return null
      return moment(this.endDate).format("DD/MM")
    },
    startDateErrors() {
      const errors = []
      if (!this.$v.startDate.$dirty) return errors
      !this.$v.startDate.required && errors.push("Campo obrigatório!")
      return errors
    },
    endDateErrors() {
      const errors = []
      if (!this.$v.endDate.$dirty) return errors
      !this.$v.endDate.required && errors.push("Campo obrigatório!")
      !this.$v.endDate.maxDateDiff && errors.push("O máximo de dias selecionados é 7")
      return errors
    },
    now() {
      return moment(moment.now()).toISOString()
    },
    minDate() {
      if (!this.startDate) return this.now
      return moment(this.startDate).toISOString()
    },
    maxDate() {
      if (!this.startDate) return null
      const startDate = moment(this.startDate)
      const maxDate = startDate.add(6, "days")
      return maxDate.toISOString()
    }
  },
  watch: {
    range: {
      deep: true,
      handler(newValue) {
        if (!newValue) return
        if (newValue[0]) this.startDate = newValue[0]
        if (newValue[1]) this.endDate = newValue[1]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.p-relative {
  position: relative !important;
}

.card__header {
  background: #10303D 0% 0% no-repeat padding-box;
  border-radius: 8px 8px 0px 0px;
  opacity: 1;

  .card__title {
    font: normal normal normal 16px/21px Roboto;
    letter-spacing: 0;
    color: #E5E8E7;
    opacity: 1;
  }
}
</style>